/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment } from 'react'
import useRootStore from '@store/useRootStore'
import { useOnMount, useOnUnmount } from '@utils/reactExt'
import { ListView } from 'antd-mobile'
import { Schema$UserPickExtend } from '@interface/user-pick'
import { UserPickItem } from '@views/Home/UserPick/Components/UserPickItem'
import * as _ from 'lodash'
import { AdvEmpty } from '@components/AdvEmpty'
import { EMPTY_ICON } from '@constants/index'
import { COMMUNICATION_BLOCK_TYPE } from '@v2/constants/common'
import { runInAction } from 'mobx'
import { CompanyPickLikeActivityListWrap } from '@views/MyPage/index.style'

interface UserPickLikeActivityProps {
  baseMonth?: string
}

export const UserPickLikeActivity: React.FC<UserPickLikeActivityProps> = observer((props) => {
  const { userPickStore } = useRootStore()
  const { userPickMyLikedList, userPickMyLikedListHasMore } = userPickStore

  const dataSource = new ListView.DataSource({
    rowHasChanged: (row1, row2) => row1 !== row2,
  })

  useOnMount(() => {
    fetch(true)
  })

  useOnUnmount(() => {
    userPickStore.resetUserPickMyLikedList()
  })


  const fetch = (reset = false) => {
    userPickStore.fetchUserPickMyLikedList(reset, props?.baseMonth).catch(console.error)
  }

  const renderHeader = (): React.ReactElement => {
    return <Fragment/>
  }

  const onUserBlockSuccessHandler = (userPromiseId: string, blockTypes: COMMUNICATION_BLOCK_TYPE[]) => {
    const isUserBlock = !_.isEmpty(blockTypes)
    const isPickBlock = _.includes(blockTypes, COMMUNICATION_BLOCK_TYPE.USER_PICK)

    runInAction(() => {
      userPickStore.userPickMyLikedList = userPickStore.setUserBlock(
        userPickMyLikedList,
        userPromiseId,
        isUserBlock,
        isPickBlock,
      )
    })
  }

  const renderRow = (row: Schema$UserPickExtend): React.ReactElement => {
    return <UserPickItem userPick={row} disableFavoriteEvent showMatchInfoSimple
                         onUserBlockSuccessHandler={onUserBlockSuccessHandler}/>
  }

  const renderFooter = (): React.ReactElement => {
    let footer
    if (_.size(userPickMyLikedList) > 0) {
      footer = <Fragment/>
    } else {
      footer = <AdvEmpty ico={EMPTY_ICON.USER_PICK_LIKE_ACTIVITY}/>
    }
    return <div css={{ textAlign: 'center' }}>{footer}</div>
  }

  const endReachedHandler = () => {
    if (userPickMyLikedListHasMore) {
      fetch()
    }
  }

  return (
    <CompanyPickLikeActivityListWrap>
      <ListView
        css={{ height: '100%' }}
        dataSource={dataSource.cloneWithRows(userPickMyLikedList ?? [])}
        renderHeader={renderHeader}
        renderRow={renderRow}
        scrollRenderAheadDistance={500}
        renderFooter={renderFooter}
        onEndReached={endReachedHandler}
        onEndReachedThreshold={10}
        initialListSize={9}
        pageSize={9}
      />
    </CompanyPickLikeActivityListWrap>
  )
})
